// React Imports
import type { SVGAttributes } from 'react'

const Logo = (props: SVGAttributes<SVGElement>) => {
  return (
    <svg width='51' height='24' viewBox='0 0 51 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path d='M6.49414 17.4541H12.9883V24H0V0H6.49414V17.4541Z' fill='black' />
      <rect
        x='22.2529'
        y='8.72656'
        width='15.2727'
        height='6.49406'
        transform='rotate(90 22.2529 8.72656)'
        fill='black'
      />
      <path d='M47.7964 23.999H41.3022V8.72656H47.7964V23.999Z' fill='black' />
      <path
        d='M31.5179 24H25.0238V17.4541H31.5179V24ZM38.0121 15.2725H25.0238V8.72754H38.0121V15.2725ZM51.0004 6.5459H25.0238V0H51.0004V6.5459Z'
        fill='url(#paint0_linear_2248_63094)'
      />
      <rect x='22.2529' width='6.54544' height='6.49406' transform='rotate(90 22.2529 0)' fill='black' />
      <defs>
        <linearGradient
          id='paint0_linear_2248_63094'
          x1='51.0465'
          y1='-4.76001e-06'
          x2='24.8158'
          y2='23.7944'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#2569ED' />
          <stop offset='1' stopColor='#2569ED' />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default Logo
